'use strict';

import groveImport from 'raw-loader!../python/grove/import.py'
import groveMoisture from 'raw-loader!../python/grove/moisture.py'
import groveJoystick from 'raw-loader!../python/grove/joystick.py'
import groveServo from 'raw-loader!../python/grove/servo.py'
import groveUltrasonicRanger from 'raw-loader!../python/grove/ultrasonicranger.py'
import groveWeather from 'raw-loader!../python/grove/weather.py'
import groveMiniMotor from 'raw-loader!../python/grove/minimotor.py'
import groveSound from 'raw-loader!../python/grove/sound.py'
import groveButton from 'raw-loader!../python/grove/button.py'
import groveVibrationMotor from 'raw-loader!../python/grove/vibrationmotor.py'
import groveSunlight from 'raw-loader!../python/grove/sunlight.py'

const DAPjs = require('dapjs');
const EventEmitter = require('events');

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
const EOT = String.fromCharCode(0x04);

function VerifyException(message) {
	this.message = message;
	this.name = 'VerifyException';
}

export default class uPy extends EventEmitter {
	constructor(daplink) {
		super();
		let that = this;
		this.daplink = daplink;
		this.daplink.on(DAPjs.DAPLink.EVENT_SERIAL_DATA, (data) => {
			that.buffer = that.buffer + data;
			that.emit('upy-rx', data);
		});
		this.library = {
			grove: {
				import: groveImport,
				moisture: groveMoisture,
				joystick: groveJoystick,
				servo: groveServo,
				ultrasonicranger: groveUltrasonicRanger,
				weather: groveWeather,
				minimotor: groveMiniMotor,
				button: groveButton,
				sound: groveSound,
				vibrationmotor: groveVibrationMotor,
				sunlight: groveSunlight
			}
		};
		this.buffer = "";
		this.upload_size = 0;
		this.upload_curr = 0;
		this.interrupted = false;
		this.connected = true;
		this.daplink.startSerialRead(50);
	}
	cancel() {
		this.interrupted = true;
	}
	async interrupt() { //Ctrl-C
		await this.send(0x03, /.*>>> /gm);
	}
	async reboot() { //Ctrl-D
		await this.send(0x04, /.*soft reboot/gm);
	}
	async pasteMode(state) {
		if (state) {
			await this.send(0x04, /.*>>> /gm);
		} else {
			await this.send(0x05, /.*=== /gm); //Ctrl-E
		}
	}
	async rawMode(state) {
		if (state) {
			await this.send(0x01, /.*raw REPL; CTRL-B to exit\r\n>/gm);
		} else {
			await this.send(0x02);
			await this.reboot();
		}
	}
	async test() {
		await this.send(0x03);
		await this.send(0x03);
		await this.send(0x01);
		await this.send(0x02);
		await this.send(0x03);
		await this.interrupt();
	}
	async upload(code) {
		console.log(code);
		let that = this;
		try {
			await this.test();
			await this.rawMode(true);
			await this.send("import os"+EOT, /.*OK[\u0004]*>/gm); 
			await this.send("try:\n");
			await this.send("\tos.remove('grove.py')\n"); //This may cause an OS Error
			await this.send("\tos.remove('main.py')\n"); //This may cause an OS Error
			await this.send("except OSError:\n");
			await this.send("\tpass\n");
			await this.send(EOT, /.*OK[\u0004]*>/gm);
			this.upload_size = code.length;
			// Build grove.py module
			let grove_library = "";
			let progress = 0;
			grove_library = code.split('\n'). // split the code by newlines
				filter(line=>line.match(/from[ ]+grove[ ]+import[ ]+(.+)/)). // filter only the lines that begin with 'from grove import '
				map(line=>line.match(/from[ ]+grove[ ]+import[ ]+(.+)/)[1]). // grab only the class names being imported
				map(i=>i.replace(/ /gi,'').split(',')) // remove spaces and split by semi-colon
			if (grove_library.length > 0) {
				grove_library = grove_library.
					reduce((p,v)=>p.concat(v)). // concat multi-arrays
					reduce((p,v)=>p.includes(v) ? p : [...p,v], []). // remove duplicates
					map(l=>l.toLowerCase() in that.library.grove ? that.library.grove[l.toLowerCase()] : `raise ImportError('cannot import name ${l}')`). // replace item with relevant library
					reduce((p,v)=>p.concat(v)) // concat array into a single string
				console.log(grove_library);
				this.upload_size = this.upload_size + grove_library.length;
				progress = Math.round((100.0/(Math.floor(this.upload_size/32)))*100)/100
				if (grove_library != "") await this.writeFile('grove.py', grove_library, progress);
			}
			await this.writeFile('main.py', code, progress);
			await this.rawMode(false);
			this.emit("upy-upload-progress", this.upload_curr=0);
		} catch (e) {
			throw e
		}
	}
	async writeFile(file, code, p) {
		await this.send("fd = open('"+file+"', 'wb')"+EOT, /.*OK[\u0004]*>/gm);
		await this.send("f = fd.write"+EOT, /.*OK[\u0004]*>/gm);
		while (code && !this.interrupted) { 
			let payload = "f("+JSON.stringify(code.substring(0, 32)).replace(/'/g, "'").replace(/"/g, "\"")+")";
			await this.send(payload+EOT, /.*OK[\u0004]*>/gm);
			this.emit("upy-upload-progress", this.upload_curr=this.upload_curr+p);
			code = code.substring(32);
		}
		await this.send("fd.close()"+EOT, /.*OK[\u0004]*>/gm)
	}
	async send(input, expected=undefined) {
		console.log('upy-tx', input, expected);
		if (typeof(input) === "number") input = String.fromCharCode(input);
		this.buffer = ""
		try {
			await this.daplink.serialWrite(input)
			if (expected) {
				let that = this;
				const promise_timeout = new Promise((resolve, reject) => setTimeout(() => resolve('timeout'), 3000));
				let promise = new Promise(async function(resolve, reject) {
				    while (!that.buffer.match(expected)) {
				    	await delay(20);
				    }
					resolve(that.buffer);
				  });
				if (await Promise.race([promise_timeout, promise]) == 'timeout') {
					throw new VerifyException(`Serial Timeout\nEXPECTED:\n${expected}\nGOT:\n"${this.buffer}"`);
				}
			} else {
				await delay(200);
			}
		} catch (e) {
			throw e
		}
	}
	disconnect() {
		// In case there's anything upy needs to do before disconnecting...
		this.daplink.stopSerialRead();
	}
}